module.exports = __webpack_public_path__ + "img/37.0601769a.jpg";